import React from 'react'
import { Wrapper, Image, Text } from './OrientationModal.style'
import type { OrientationModalProps } from './OrientationModal.types'
import { Button, Modal, tokens } from '@arvoreeducacao/bonsai-ds'
import useUserPlatform from 'utils/hooks/use-platform'
import { Trans, useTranslation } from 'i18n'
import { Cdn } from 'utils/assets'

const OrientationModal: React.FC<OrientationModalProps> = ({
  open,
  onClose
}) => {
  const { t } = useTranslation()
  const { windowWidth } = useUserPlatform()

  return (
    <Modal
      portalContainer={document.getElementById('modal')}
      type={'standard'}
      isOpen={open && windowWidth <= tokens.breakpoints.tabletSmall}
      size={'small'}
      sheetHeaderProps={{
        type: 'close',
        onClose: onClose,
        title: t('Marcar como lido')
      }}
      title={t('Marcar como lido')}
      titleSize={4}
      onClose={onClose}
      hasDesktopCloseButton
    >
      <Wrapper>
        <Image
          src={Cdn.getImageUrl(t('my-readings/ilustra-marcar-como-lido.webp'))}
        />
        <Text>
          <Trans
            i18nKey={
              'Para <strong>marcar um livro como lido</strong>, basta clicar nos 3 pontinhos abaixo do livro e selecionar "marcar como lido". Isso fará com que ele vá para a sessão de Lidos.'
            }
          />
        </Text>
        <Button
          theme={{ type: 'primaryLivros', size: 'xLarge' }}
          text={t('Entendi')}
          onClick={onClose}
          fluid
        />
      </Wrapper>
    </Modal>
  )
}
export default OrientationModal
